import { useEffect, useState } from "react";
import BarChart from "../Charts/BarChart"
import SortByDescAndTemplate from "../AI-Description-Title/sortBy-desc-template";
import { GetPhotoUsage, GetStats, GetStatsUsages } from "../../Services/Settings";
import { LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const HomePage: React.FunctionComponent<{}> = (props) => {

    const [activeTabValue, setActiveTabValue] = useState('monthly');
    const tabs = ['monthly', 'weekly'];
    const [statsValue, setStatsValue] = useState<any>([]);
    const [statsUsage, setStatsUsage] = useState<any>([]);
    const [dataValue, setDataValue] = useState<any>();
    const [isLoading, setIsLoading] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        GetStats().then((resp) => {
            setStatsValue(resp.data)
            setIsLoading(false)
        }).catch(() => {
            console.log("error")
        })
        GetStatsUsages().then((resp) => {
            setStatsUsage(resp.data)
            setIsLoading(false)
        }).catch(() => {
            console.log("error")
        })
    }, [])

    useEffect(() => {
        GetPhotoUsage(activeTabValue).then((resp) => {
            setDataValue(resp.data)
        }).catch(() => {
            console.log("error")
        })
    }, [activeTabValue])

    return isLoading ? <div className="container-xxl flex-grow-1 container-p-y marg-bottom-100 ">loading...</div> : (

        <div className="container-xxl flex-grow-1 container-p-y marg-bottom-100 ">

            <div className="row mb-4">
                <div className="card border-20">
                    <div className="padd-24">
                        {/* <div className="d-flex mt-4 justify-content-end">
                            <Filters />
                        </div> */}
                        <div className="row mt-4">
                            <div className="grid-home">
                                <div className="back-F8FAFC border-20 text-center ">
                                    <img src="/assets/images/icons/enhanced-photos.svg" className="img-home" />
                                    <h3 className="title-28 title-24-mb mt-2">{statsValue.enhancedPhotos}</h3>
                                    <h5 className="title-18 para-16-mb bold-500">{t('home.enhancedPhotos')}</h5>
                                </div>
                                <div className="back-F8FAFC border-20 text-center ">
                                    <img src="/assets/images/icons/generated-photos.svg" className="img-home" />
                                    <h3 className="title-28 title-24-mb mt-2">{statsValue.generatedPhotos}</h3>
                                    <h5 className="title-18 para-16-mb bold-500">{t('home.generatedPhotos')}</h5>
                                </div>
                                <div className="back-F8FAFC border-20 text-center ">
                                    <img src="/assets/images/icons/created-listings.svg" className="img-home" />
                                    <h3 className="title-28 title-24-mb mt-2">{statsValue.createdListings}</h3>
                                    <h5 className="title-18 para-16-mb bold-500">{t('home.createdListings')}</h5>
                                </div>
                                <div className="back-F8FAFC border-20 text-center ">
                                    <img src="/assets/images/icons/generated-descriptions.svg" className="img-home" />
                                    <h3 className="title-28 title-24-mb mt-2">{statsValue.generatedDescriptions}</h3>
                                    <h5 className="title-18 para-16-mb bold-500">{t('home.generatedDescriptions')}</h5>
                                </div>
                                <div className="back-F8FAFC border-20 text-center ">
                                    <img src="/assets/images/icons/social-media-post.svg" className="img-home" />
                                    <h3 className="title-28 title-24-mb mt-2">{statsValue.socialMediaPosts}</h3>
                                    <h5 className="title-18 para-16-mb bold-500">{t('home.socialMediaPost')}</h5>
                                </div>
                                <div className="back-F8FAFC border-20 text-center ">
                                    <img src="/assets/images/icons/generated-videos.svg" className="img-home" />
                                    <h3 className="title-28 title-24-mb mt-2">{statsValue.generatedVideos}</h3>
                                    <h5 className="title-18 para-16-mb bold-500">{t('home.generatedVideos')}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="card border-20">
                    <div className="padd-24">
                        <div className="row mb-4 d-flex align-items-center">
                            <div className="col">
                                <h2 className="title-24 title-20-mb font-Roboto">{t('home.photoUsage')}</h2>
                            </div>
                            <div className="col d-flex justify-content-end">
                                <div className="tabs-Monthly">
                                    {tabs.map((tab) => (
                                        <button
                                            key={tab}
                                            className={`tab-button ${activeTabValue === tab ? 'active' : ''}`}
                                            onClick={() => setActiveTabValue(tab)}
                                        >
                                            {`${t(`home.${tab}`)}`.charAt(0).toUpperCase() + `${t(`home.${tab}`)}`.slice(1)}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <BarChart data={dataValue} />
                    </div>
                </div>
            </div>

            <div className="row mb-4">
                <div className="col-md-6">
                    <div className="card mb-4 border-20">
                        <div className="padd-24">
                            <h2 className="title-18  font-Roboto mb-3">{t('sidebar.users')}</h2>
                            <div className="table-responsive text-nowrap border-12" >
                                <table className="table agency-table">
                                    <thead className="table-header">
                                        <tr>
                                            <th className="para-14 font-Roboto bold-800 text-start">
                                                {t('home.name')}
                                            </th>
                                            <th className="para-14 font-Roboto bold-800 text-end">
                                                {t('home.usage')}
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {statsUsage.agents && statsUsage.agents.map((agent: any, index: number) => {
                                            const percentage = (agent.usage / Math.max(...statsUsage.agents.map((f: any) => f.usage))) * 100;
                                            return (<tr key={index}>
                                                <td className="text-start para-14 bold-500 font-Roboto">{agent.name}</td>
                                                <td className="text-end">
                                                    <div className="usage-bar-container">
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={percentage}
                                                            className="usage-bar"
                                                            sx={{
                                                                backgroundColor: "#efeff5 !important",
                                                                '& .MuiLinearProgress-bar': {
                                                                    backgroundColor: " #6366f1 !important",
                                                                }
                                                            }}
                                                        />
                                                        <span className="usage-value">{agent.usage}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card mb-4 border-20">
                        <div className="padd-24">
                            <h2 className="title-18 font-Roboto mb-3"> {t('home.features')}  </h2>
                            <div className="table-responsive text-nowrap border-12" >
                                <table className="table agency-table">
                                    <thead className="table-header">
                                        <tr>
                                            <th className="para-14 font-Roboto bold-800 text-start">
                                                {t('home.name')}
                                            </th>
                                            <th className="para-14 font-Roboto bold-800 text-end">
                                                {t('home.usage')}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {statsUsage.features && statsUsage.features.map((feature: any, index: number) => {
                                            const percentage = (feature.usage / Math.max(...statsUsage.features.map((f: any) => f.usage))) * 100;
                                            return (<tr key={index}>
                                                <td className="text-start para-14 bold-500 font-Roboto">{feature.name}</td>
                                                <td className="text-end">
                                                    <div className="usage-bar-container">
                                                        <LinearProgress
                                                            variant="determinate"
                                                            value={percentage}
                                                            className="usage-bar"
                                                            sx={{
                                                                backgroundColor: "#efeff5 !important",
                                                                '& .MuiLinearProgress-bar': {
                                                                    backgroundColor: " #6366f1 !important",
                                                                }
                                                            }}
                                                        />
                                                        <span className="usage-value">{feature.usage}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomePage
